/**
 * Created by lei_sun on 2019/7/9.
 */
import serviceFetch from '../../serviceFetch'
import ProjectConfig from '../../../../project.config'
import { UtilCommon } from '@iskytrip/sdk'

let serviceObj = {}

serviceObj.getPriceDate = function(obj) {
	const json = {
		header: UtilCommon.getResponseHeader(),
		request: {
			...obj,
		},
	}
	return new Promise((resolve, reject) => {
		serviceFetch(ProjectConfig.serviceFlight + '/flight/getLowFareCalendar', json)
			.then((res) => {
				resolve(res)
			})
			.catch(reject)
	})
}

serviceObj.getHoliday = function(obj) {
	const json = {
		header: UtilCommon.getResponseHeader(),
		request: {
			...obj,
		},
	}
	return new Promise((resolve, reject) => {
		serviceFetch(ProjectConfig.serviceHoliday + '/holiday/getHolidayList', json)
			.then((res) => {
				resolve(res)
			})
			.catch(reject)
	})
}
export default serviceObj
